import React from "react";
import { useParams } from "react-router-dom";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";

const BlogUniquePage = () => {
  const { blogListApi } = apiPath;
  const blogName = useParams();
  const [blog, blogLoading] = useFetch(blogListApi, false, blogName.id);
  if (blogLoading) {
    return <Loading />;
  }

  const {
    category,
    blogTitle,
    img,
    mainDescriptionTitle,
    mainDescription,
    description,
    date,
    author,
  } = blog;

  const dynamicDetailData = [];
  description.map((item, index) => {
    dynamicDetailData.push({
      label: `Detail ${index}`,
      type: "text",
      name: "",
      defaultValue: item,
      required: false,
    });
  });

  const data = [
    {
      elementType: "file",
      label: "Banner Image",
      type: "file",
      name: "img",
      defaultValue: img,
      required: true,
    },
    {
      elementType: "input",
      label: "Blog Title",
      type: "Text",
      name: "blogTitle",
      defaultValue: blogTitle,
      required: true,
    },
    {
      elementType: "select",
      label: "Blog Category",
      type: "Text",
      name: "category",
      defaultValue: category,
      required: true,
      options: ["News", "Blog", "Event"],
    },
    {
      elementType: "input",
      label: "Main Description Title",
      type: "Text",
      name: "mainDescriptionTitle",
      defaultValue: mainDescriptionTitle,
      required: true,
    },
    {
      elementType: "input",
      label: "Author Title",
      type: "Text",
      name: "author",
      defaultValue: author,
      required: true,
    },
    {
      elementType: "input",
      label: "Date",
      type: "date",
      name: "date",
      defaultValue: date,
      required: false,
    },
    {
      elementType: "textField",
      label: "Main Description",
      type: "Text",
      name: "mainDescription",
      defaultValue: mainDescription,
      required: true,
    },
  ];

  const multiDimensionalMultipleData = [
    {
      elementType: "nestedMultiple",
      label: "Blog Details",
      name: "description",
      multipleData: dynamicDetailData,
      multiple: true,
      required: false,
    },
  ];
  const useData = data.concat(multiDimensionalMultipleData);

  const update = (data) => {
    updateData(`${blogListApi}/${blogName.id}`, data);
  };

  return (
    <div>
      <GlobalForm
        data={useData}
        multiDimensionalMultipleData={multiDimensionalMultipleData}
        update={update}
      />
    </div>
  );
};

export default BlogUniquePage;
